<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="刷手號" prop="userNum">
                <a-input v-model="queryParam.userNum" placeholder="請輸入刷手號" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手機號" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="請輸入用戶手機號" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="暱稱" prop="userName">
                <a-input v-model="queryParam.userName" placeholder="請輸入用戶暱稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收支類型" prop="inOut">
                <a-select v-model="queryParam.inOut">
                  <a-select-option :value="1">
                    收入
                  </a-select-option>
                  <a-select-option :value="-1">
                    支出
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="時間">
                <a-range-picker
                  :placeholder="['開始時間', '結束時間']"
                  @change="onDateChange"
                  format="YYYY-MM-DD"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />導出
        </a-button>
        <a-button type="primary" @click="handleTotalExport">
          <a-icon type="download" />匯總
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageIntegralBill,listIntegralBill, delIntegralBill } from '@/api/platform/integralBill'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'IntegralBill',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        userId: null,
        inOut: null,
        type: null,
        resourceId: null,
        integralNum: null,
        message: null,
        userNum:null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '刷手號',
          dataIndex: 'userNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手機號',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用戶暱稱',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '收支類型',
          dataIndex: 'inOut',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == -1) {
              return "支出"
            }
            if (value == 1) {
              return "收入"
            }
          }
        },
        {
          title: '類型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "充值"
            }
            if (value == 2) {
              return "完成任務"
            }
            if (value == 3) {
              return "完成任務"
            }
            if (value == 4) {
              return "參與PK"
            }
            if (value == 8) {
              return "會員購買"
            }
            if (value == 9) {
              return "拒絕開啟PK費用"
            }
            if (value == 10) {
              return "直播"
            }
            if (value == 12) {
              return "轉發任務"
            }
            if (value == 15) {
              return "購買曝光"
            }
            if (value == 16) {
              return "購買熱門"
            }
            if (value == 99) {
              return "平臺更新"
            }
          }
        },
        {
          title: '產品Id',
          dataIndex: 'productId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '米幣數量',
          dataIndex: 'integralNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '說明',
          dataIndex: 'message',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '新增時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢米幣流水業務列表 */
    getList () {
      this.loading = true
     pageIntegralBill(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onDateChange(value, dateString) {
      console.log(dateString[0],dateString[1]);
      this.queryParam.startTime=dateString[0];
      this.queryParam.endTime=dateString[1];
    },
    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        inOut: undefined,
        type: undefined,
        resourceId: undefined,
        integralNum: undefined,
        message: undefined,
        userNum:undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delIntegralBill(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    handleTotalExport(){

      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/integral-bill/exportSummary', {
            ...that.queryParam
          }, `米幣流水匯總_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/integral-bill/export', {
            ...that.queryParam
          }, `米幣流水業務_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
